<div class="dialog-content">
  <h2 mat-dialog-title>{{ data.dialogTitle }}</h2>
  <mat-dialog-content>
    <div class="banner" *ngIf="data.cautionaryMessage">
      <div style="display: flex; gap: 8px">
        <mat-icon class="icon">warning_amber</mat-icon>
        <div>{{ data.cautionaryMessage }}</div>
      </div>
    </div>
    {{ data.description }}
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
    <button mat-raised-button color="primary" (click)="ok()">
      {{ okButtonTitle }}
    </button>
  </mat-dialog-actions>
</div>
